import {
  Box,
  Button,
  ButtonBase,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Radio,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  useTheme
} from '@material-ui/core'
import clsx from 'clsx'
import { FieldArray, Form, Formik } from 'formik'
import { head } from 'lodash'
import {
  Check,
  Edit2,
  Headset,
  Minus,
  List,
  Paperclip,
  Star,
  Trash2,
  Workflow,
  CircleSmall
} from 'lucide-react'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { getBackendURL } from '../../services/config'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import ConfirmationModal from '../ConfirmationModal'
import InputMessage from '../InputMessage'
import { InputField } from '../InputField'
import { InputSwitch } from '../InputSwitch'
import { UsersSelect } from '../UsersSelect'
import { useStyles } from './styles'

import flowDepartment from '../../assets/flow_department.png'
import flowMenu from '../../assets/flow_menu.png'
import { AttachmentInput } from '../AttachmentInput'
import { AuthContext } from '../../context/Auth/AuthContext'
import { UsersFilter } from '../UsersFilter'

const getValidationSchema = activeStep =>
  Yup.lazy(values =>
    Yup.object().shape({
      parentName:
        activeStep >= 1 && values?.menuDepartment
          ? Yup.string().required('O nome do menu principal é obrigatório')
          : Yup.string().nullable(),
      subDepartments:
        activeStep >= 1 && values?.menuDepartment
          ? Yup.array().min(1, 'Adicione pelo menos um item na lista')
          : Yup.array().nullable()
    })
  )

const steps = ['Tipo de Fluxo', 'Dados do Fluxo', 'Revisão']

const DepartmentModal = ({ open, onClose, option, onFlowUpdate, onSaved }) => {
  const classes = useStyles()
  const theme = useTheme()
  const { loadUser } = useContext(AuthContext)

  const [optionAttachment, setOptionAttachment] = useState(null)
  const optionAttachmentFile = useRef({})
  const [confirmationOpenOption, setConfirmationOpenOption] = useState(false)
  const [confirmationOpenDepartment, setConfirmationOpenDepartment] =
    useState(false)
  const [deleteConfirmationText, setDeleteConfirmationText] = useState('')
  const [selectedOption, setSelectedOption] = useState(option)
  const [, setQueueUsers] = useState([])
  const [, setLoadingQueueUsers] = useState(false)
  const [, setMediaDeleted] = useState(false)
  const [, setUsersChanged] = useState(false)

  const [imagePreviewOpen, setImagePreviewOpen] = useState(false)
  const [previewUrl, setPreviewUrl] = useState(null)
  const [initialData, setInitialData] = useState(null)

  const mediaPathOnLoad = useRef(null)

  const [schedules] = useState([
    {
      weekday: 'Segunda-feira',
      weekdayEn: 'monday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Terça-feira',
      weekdayEn: 'tuesday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Quarta-feira',
      weekdayEn: 'wednesday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Quinta-feira',
      weekdayEn: 'thursday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Sexta-feira',
      weekdayEn: 'friday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Sábado',
      weekdayEn: 'saturday',
      startTime: '08:00',
      endTime: '12:00'
    },
    {
      weekday: 'Domingo',
      weekdayEn: 'sunday',
      startTime: '00:00',
      endTime: '00:00'
    }
  ])

  const [queueOptions, setQueueOptions] = useState(null)

  const isEditing = !!option?.id
  const [activeStep, setActiveStep] = useState(0)
  const [usersSelectKey, setUsersSelectKey] = useState(0)

  const [isEditingSubIndex, setIsEditingSubIndex] = useState(null)
  const [tempSub, setTempSub] = useState({
    name: '',
    greetingMessage: '',
    exitChatbot: false,
    users: [],
    attachmentFile: null,
    mediaPath: null,
    mediaName: null
  })

  const handleNext = () => setActiveStep(prev => prev + 1)
  const handleBack = () => setActiveStep(prev => prev - 1)
  const handleReset = () => setActiveStep(0)

  const createEmptySubDepartment = () => ({
    name: '',
    greetingMessage: '',
    exitChatbot: false,
    users: [],
    attachmentFile: null,
    mediaPath: null,
    mediaName: null
  })

  const renderFlowTypeCard = ({
    isActive,
    disabled,
    onClick,
    chipIcon,
    chipLabel,
    titleIcon,
    title,
    description,
    exampleNode,
    exampleText, // <-- NOVA PROP
    exampleImage,
    imageWidth // <-- NOVA PROP
  }) => (
    <ButtonBase
      component="div"
      disabled={disabled}
      onClick={onClick}
      role="radio"
      aria-checked={isActive}
      className={classes.buttonBase}
      style={{
        backgroundColor: isActive
          ? theme.palette.blue_300.main + '1A'
          : 'transparent',
        border: isActive
          ? `1px solid ${theme.palette.blue_300.main}`
          : theme.palette.type === 'dark'
            ? `1px solid ${theme.palette.dark_stroke.main}`
            : `1px solid ${theme.palette.gray_stroke.main}`,
        opacity: disabled && !isActive ? 0.6 : 1
      }}
    >
      <Box>
        <Chip
          className={
            isActive ? classes.chipMenuOption : classes.chipMenuDepartment
          }
          icon={chipIcon}
          label={chipLabel}
        />
      </Box>

      <Grid item xs={12}>
        <div
          className={clsx(classes.helpTitleText, {
            [classes.dialogTitleActiveOption]: isActive
          })}
        >
          <Grid item xs={1}>
            {titleIcon}
          </Grid>
          <Grid item xs={11}>
            <div className={classes.titleFlow}>{title}</div>
            <Typography
              variant="body1"
              component="div"
              className={classes.helpText}
            >
              {description}
            </Typography>
          </Grid>
        </div>
      </Grid>

      <Box className={classes.boxExample}>{exampleNode}</Box>

      <Box className={classes.contentExample}>
        <span>
          <strong>Exemplo: </strong>
          {exampleText}
        </span>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {/* Aplicando a prop imageWidth dinamicamente */}
          <img
            width={imageWidth}
            src={exampleImage}
            alt={`Imagem do Fluxo ${title}`}
          />
        </div>
      </Box>
    </ButtonBase>
  )

  const loadInitialData = useCallback(async () => {
    if (option) {
      const isDepartment = option.notificationact === true

      let subDepartments = []
      if (isDepartment) {
        let options = option.options || []
        try {
          const { data } = await api.get('/queue-options', {
            params: { queueId: option.id, parentId: -1 }
          })
          options = data
        } catch (error) {
          console.error(
            `Erro ao buscar subdepartamentos da fila ${option.id}:`,
            error
          )
        }

        subDepartments = await Promise.all(
          options.map(async item => {
            let queueDetails = {}

            if (item.forwardQueueId) {
              try {
                const { data } = await api.get(`/queue/${item.forwardQueueId}`)
                queueDetails = data
              } catch (error) {
                console.error(
                  `Erro ao buscar dados da fila ${item.forwardQueueId}:`,
                  error
                )
              }
            }

            return {
              id: item.forwardQueueId,
              queueOptionId: item.id,
              name: item.title || item.name || '',
              forwardQueueId: item.forwardQueueId,
              queueId: item.queueId,
              greetingMessage:
                queueDetails.greetingMessage || item.message || '',
              exitChatbot:
                queueDetails.exitChatbot || item.exitChatbot || false,
              mediaPath: queueDetails.mediaPath || item.mediaPath || null,
              mediaName: queueDetails.mediaName || item.mediaName || null,
              users: queueDetails.users || item.users || []
            }
          })
        )
      } else {
        subDepartments = [
          {
            id: option.id,
            name: option.title || option.name || '',
            greetingMessage: option.greetingMessage || '',
            exitChatbot: option.exitChatbot || false,
            mediaPath: option.mediaPath || null,
            mediaName: option.mediaName || null,
            users: option.users || []
          }
        ]
      }
      mediaPathOnLoad.current = isDepartment ? null : option.mediaPath || null
      setInitialData({
        id: option.id,
        name: option.name || '',
        title: option.title || '',
        greetingMessage: option.greetingMessage || '',
        mediaPath: option.mediaPath || null,
        mediaName: option.mediaName || null,
        users: option.users || [],
        parentName: isDepartment ? option.title || option.name : '',
        menuOption: !isDepartment,
        menuDepartment: isDepartment,
        subDepartments: subDepartments
      })

      if (!isDepartment) {
        setTempSub(subDepartments[0])
      } else {
        setTempSub(createEmptySubDepartment())
      }
    } else {
      mediaPathOnLoad.current = null
      setInitialData({
        parentName: '',
        menuOption: false,
        menuDepartment: false,
        subDepartments: []
      })
      setTempSub(createEmptySubDepartment())
    }
  }, [option])

  useEffect(() => {
    if (!open) handleReset()
  }, [open])

  useEffect(() => {
    if (open) {
      loadInitialData()
      setActiveStep(isEditing && option?.notificationact === true ? 1 : 0)
    } else {
      setInitialData(null)
    }
  }, [open, isEditing, loadInitialData, option?.notificationact])

  useEffect(() => {
    setSelectedOption(option)
    setMediaDeleted(false)
    setUsersChanged(false)
    if (option) {
      setOptionAttachment(null)
      if (option) {
        fetchQueueUsers(option.id)
      } else {
        setQueueUsers([])
      }
    }
  }, [option])

  const fetchQueueUsers = async queueId => {
    if (!queueId) return

    setLoadingQueueUsers(true)
    try {
      const { data } = await api.get(`/queue/${queueId}`)
      setQueueUsers(data.users || [])
    } catch (error) {
      console.error('Erro ao buscar usuários da queue:', error)
      setQueueUsers([])
    } finally {
      setLoadingQueueUsers(false)
    }
  }

  const handleOptionChange = (field, value) => {
    setSelectedOption(prev => ({ ...prev, [field]: value }))
    if (field === 'users') {
      setUsersChanged(true)
    }
  }

  const deleteOptionMedia = async () => {
    if (optionAttachment) {
      setOptionAttachment(null)
      if (optionAttachmentFile.current) {
        optionAttachmentFile.current.value = null
      }
      handleOptionChange('mediaPath', null)
      handleOptionChange('mediaName', null)
      setConfirmationOpenOption(false)
      toast.success('Anexo removido com sucesso!')
      return
    }

    if (selectedOption?.mediaPath) {
      setMediaDeleted(true)

      handleOptionChange('mediaPath', null)
      handleOptionChange('mediaName', null)

      if (!optionAttachment) {
        toast.success(
          'Anexo marcado para exclusão. Clique em Salvar para confirmar.'
        )
      }
    }
    setConfirmationOpenOption(false)
  }

  const handleDeleteOptions = () => {
    setConfirmationOpenDepartment(true)
  }

  // const handleConfirmDeleteDepartment = async () => {
  //   if (deleteConfirmationText === 'EXCLUIR') {
  //     try {
  //       if (!option || !option.id) {
  //         toast.error('Erro: Opção inválida para deletar')
  //         setConfirmationOpenDepartment(false)
  //         return
  //       }
  //       await api.delete(`/queue/${option.id}`)

  //       if (queueOptions?.forwardQueueId === option.id) {
  //         await api.delete(`/queue-options/${queueOptions.id}`)
  //       }
  //       toast.success('Fluxo deletado com sucesso!')
  //       if (onFlowUpdate) {
  //         onFlowUpdate()
  //       }
  //       onClose()
  //     } catch (err) {
  //       toastError(err)
  //     } finally {
  //       setConfirmationOpenDepartment(false)
  //       setDeleteConfirmationText('')
  //     }
  //   } else {
  //     toast.error(
  //       'O texto de confirmação está incorreto. Digite EXCLUIR em letras maiúsculas.'
  //     )
  //   }
  // }

  const handleConfirmDeleteDepartment = useCallback(async () => {
    if (deleteConfirmationText !== 'EXCLUIR') {
      toast.error(
        'O texto de confirmação está incorreto. Digite EXCLUIR em letras maiúsculas.'
      )
      return
    }

    if (!option?.id) {
      toast.error('Erro: Opção inválida para deletar')
      setConfirmationOpenDepartment(false)
      return
    }

    try {
      const isCompositeFlow = option.notificationact === true

      if (isCompositeFlow && option.options?.length > 0) {
        const deletionPromises = option.options.map(async subItem => {
          if (subItem.id) {
            await api
              .delete(`/queue-options/${subItem.id}`)
              .catch(err =>
                console.error(
                  `Erro ao deletar queue-option filho ${subItem.id}:`,
                  err
                )
              )
          }
          if (subItem.forwardQueueId) {
            await api
              .delete(`/queue/${subItem.forwardQueueId}`)
              .catch(err =>
                console.error(
                  `Erro ao deletar sub-queue filho ${subItem.forwardQueueId}:`,
                  err
                )
              )
          }
        })

        await Promise.all(deletionPromises)
      }
      try {
        const { data: allOptions } = await api.get('/queue-options')
        const parentQueueOption = allOptions.find(
          opt => opt.forwardQueueId === option.id
        )

        if (parentQueueOption?.id) {
          await api.delete(`/queue-options/${parentQueueOption.id}`)
        }
      } catch (searchError) {
        console.warn(
          'Não foi possível buscar/deletar o Vendas na tabela queueoptions:',
          searchError
        )
      }
      if (queueOptions?.id) {
        await api.delete(`/queue-options/${queueOptions.id}`).catch(() => { })
      }
      await api.delete(`/queue/${option.id}`)

      toast.success(
        'Fluxo completo (Vendas e Subdepartamentos) deletado com sucesso!'
      )

      if (onFlowUpdate) onFlowUpdate()
      onClose()
    } catch (err) {
      console.error('Erro crítico ao deletar estrutura de fluxo:', err)
      toastError(err)
    } finally {
      setConfirmationOpenDepartment(false)
      setDeleteConfirmationText('')
    }
  }, [deleteConfirmationText, option, queueOptions, onFlowUpdate, onClose])

  const handleUpdateFlow = async values => {
    try {
      if (values.menuDepartment) {
        await api.put(`/queue/${values.id}`, {
          name: values.parentName,
          notificationact: true,
          schedules
        })
      }

      let optionIndex = 1

      for (const sub of values.subDepartments) {
        if (sub.id) {
          await api.put(`/queue/${sub.id}`, {
            name: sub.name,
            greetingMessage: sub.greetingMessage,
            exitChatbot: sub.exitChatbot
          })

          if (sub.queueOptionId) {
            await api.put(`/queue-options/${sub.queueOptionId}`, {
              title: sub.name,
              exitChatbot: sub.exitChatbot
            })
          } else {
            try {
              const { data: optionsList } = await api.get('/queue-options')
              const optionRecord = optionsList.find(
                o => o.forwardQueueId === sub.id
              )
              if (optionRecord) {
                await api.put(`/queue-options/${optionRecord.id}`, {
                  title: sub.name,
                  exitChatbot: sub.exitChatbot
                })
              }
            } catch (e) {
              console.error('Erro ao buscar/atualizar queue-options', e)
            }
          }

          try {
            if (sub.attachmentFile) {
              const formData = new FormData()
              formData.append('file', sub.attachmentFile)
              await api.post(`/queue/${sub.id}/media-upload`, formData)
            } else if (
              sub.mediaPath === null &&
              mediaPathOnLoad.current !== null
            ) {
              await api.delete(`/queue/${sub.id}/media-upload`)
            }
          } catch (e) {
            console.error('Erro ao processar mídia:', e)
          }

          if (sub.users) {
            try {
              const isQueue = !!(sub.forwardQueueId || sub.id)
              await handleUserBinding(sub.id, isQueue, sub.users)
            } catch (e) {
              console.error(
                `Erro ao vincular usuários no subdepartamento ${sub.name}:`,
                e
              )
            }
          }
        } else {
          const newQueueData = {
            name: sub.name,
            greetingMessage: sub.greetingMessage,
            description: '',
            schedules,
            isBot: false,
            notificationact: false
          }

          const { data: newQueue } = await api.post('/queue', newQueueData)

          if (values.menuDepartment) {
            const optionData = {
              title: sub.name,
              option: optionIndex,
              exitChatbot: sub.exitChatbot || false,
              queueId: values.id,
              forwardQueueId: newQueue.id,
              parentId: null
            }
            await api.post('/queue-options', optionData)
          }

          if (sub.attachmentFile) {
            const formData = new FormData()
            formData.append('file', sub.attachmentFile)
            await api.post(`/queue/${newQueue.id}/media-upload`, formData)
          }

          if (sub.users && sub.users.length > 0) {
            await handleUserBinding(newQueue.id, true, sub.users)
          }
        }

        optionIndex++
      }

      toast.success('Fluxo atualizado com sucesso!')
      return { ...values }
    } catch (err) {
      toastError(err)
      return null
    }
  }

  const handleCreateFlow = async values => {
    const isDepartment = !!values.menuDepartment
    let parentQueueData = null

    if (isDepartment && values.parentName) {
      const { data: parentQueue } = await api.post('/queue', {
        name: values.parentName,
        schedules,
        isBot: false,
        notificationact: true
      })
      parentQueueData = parentQueue
    }

    let optionIndex = 1
    for (const sub of values.subDepartments) {
      const newQueueData = {
        name: sub.name,
        greetingMessage: sub.greetingMessage,
        description: '',
        schedules,
        isBot: false,
        notificationact: false
      }

      const { data: newQueue } = await api.post('/queue', newQueueData)

      if (isDepartment) {
        const optionData = {
          title: sub.name,
          option: optionIndex++,
          exitChatbot: sub.exitChatbot || false,
          queueId: parentQueueData.id,
          forwardQueueId: newQueue.id,
          parentId: null
        }
        await api.post('/queue-options', optionData)
      } else {
        if (onSaved) onSaved(newQueue)
      }

      if (sub.attachmentFile) {
        const formData = new FormData()
        formData.append('file', sub.attachmentFile)
        await api.post(`/queue/${newQueue.id}/media-upload`, formData)
      }

      if (sub.users && sub.users.length > 0) {
        await handleUserBinding(newQueue.id, true, sub.users)
      }
    }

    if (isDepartment && parentQueueData) {
      if (onSaved) onSaved(parentQueueData)
    }

    toast.success('Fluxos criados com sucesso!')
    if (onFlowUpdate) onFlowUpdate()
    return true
  }

  const handleSave = async values => {
    try {
      const saved = values.id
        ? await handleUpdateFlow(values)
        : await handleCreateFlow(values)

      if (saved) {
        await loadUser() // <--- CHAME AQUI
        onClose()
      }
      return saved
    } catch (err) {
      toastError(err)
      return null
    }
  }

  const handleUserBinding = async (targetId, isQueue, usersToBind) => {
    try {
      const { data: currentQueueState } = isQueue
        ? await api.get(`/queue/${targetId}`)
        : await api.get(`/queue-options/${targetId}`)

      const currentlyLinkedUsers = currentQueueState.users || []

      const usersToRemove = currentlyLinkedUsers.filter(
        u => !usersToBind.find(user => user.id === u.id)
      )

      const usersToAdd = usersToBind.filter(
        u => !currentlyLinkedUsers.find(user => user.id === u.id)
      )

      await Promise.all(
        usersToRemove.map(async user => {
          const { data: userData } = await api.get(`/users/${user.id}`)
          const newQueueIds = isQueue
            ? (userData.queues || [])
              .filter(q => q.id !== targetId)
              .map(q => q.id)
            : (userData.queueOptions || [])
              .filter(o => o.id !== targetId)
              .map(o => o.id)

          return api.put(`/users/${user.id}`, {
            [isQueue ? 'queueIds' : 'queueOptionIds']: newQueueIds
          })
        })
      )

      // 5. Execução das adições (em paralelo)
      await Promise.all(
        usersToAdd.map(async user => {
          const { data: userData } = await api.get(`/users/${user.id}`)
          const currentIds = isQueue
            ? (userData.queues || []).map(q => q.id)
            : (userData.queueOptions || []).map(o => o.id)

          return api.put(`/users/${user.id}`, {
            [isQueue ? 'queueIds' : 'queueOptionIds']: [...currentIds, targetId]
          })
        })
      )
    } catch (error) {
      console.error('Erro crítico na sincronização:', error)
      throw error
    }
  }

  const getMediaUrl = (dynamicPath = null) => {
    if (dynamicPath) {
      if (dynamicPath.startsWith('http') || dynamicPath.startsWith('blob:')) {
        return dynamicPath
      }
      return `${getBackendURL()}/public/${dynamicPath}`
    }

    if (optionAttachment) {
      return URL.createObjectURL(optionAttachment)
    }
    if (selectedOption?.mediaPath) {
      if (selectedOption.mediaPath.startsWith('http')) {
        return selectedOption.mediaPath
      }
      return `${getBackendURL()}/public/${selectedOption.mediaPath}`
    }
    return null
  }

  const renderStepContent = (
    step,
    { values, touched, errors, setFieldValue }
  ) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.contentTitle}>
              <h2 className={classes.title}>
                Como será esse fluxo de atendimento?
              </h2>
              <span>
                Escolha a estrutura que melhor representa o caminho do cliente
                no atendimento
              </span>
            </Grid>
            <Grid item xs={12} className={classes.boxHelp}>
              {/* Card Fluxo Simples */}
              {renderFlowTypeCard({
                isActive: values.menuOption,
                disabled: isEditing,
                onClick: () => {
                  if (!values.menuOption) {
                    setFieldValue('menuOption', true)
                    setFieldValue('menuDepartment', false)
                    setFieldValue('parentName', '')
                    setFieldValue('subDepartments', [])
                    setTempSub(createEmptySubDepartment())
                    setIsEditingSubIndex(null)
                    setUsersSelectKey(prev => prev + 1)
                  }
                },
                chipIcon: <Check size={16} />,
                chipLabel: 'Mais Simples',
                titleIcon: <List />,
                title: 'Fluxo simples por departamentos',
                description:
                  'Aqui o cliente escolhe diretamente um departamento da lista sem subdepartamento, é onde os atendentes escolhidos ficarão disponíveis para receber os clientes.',
                exampleText:
                  'O cliente escolhe uma opção e segue direto para o atendente.',
                exampleImage: flowMenu,
                imageWidth: 120,
                exampleNode: (
                  <>
                    <div className={classes.exampleFlow}>
                      <Radio disabled className={classes.checkbox} />
                      <strong>1</strong> Vendas
                    </div>
                    <Headset size={18} />
                  </>
                )
              })}

              {/* Card Fluxo Completo */}
              {renderFlowTypeCard({
                isActive: values.menuDepartment,
                disabled: isEditing && option?.notificationact === true,
                onClick: () => {
                  if (!values.menuDepartment) {
                    setFieldValue('menuOption', false)
                    setFieldValue('menuDepartment', true)
                    setFieldValue('parentName', option?.name || '')
                    setFieldValue('subDepartments', [])
                    setTempSub(createEmptySubDepartment())
                    setIsEditingSubIndex(null)
                    setUsersSelectKey(prev => prev + 1)
                  }
                },
                chipIcon: <Star size={16} />,
                chipLabel: 'Mais Completo',
                titleIcon: <Workflow />,
                title: 'Fluxo com menu e subdepartamentos',
                description:
                  'Aqui você cria um menu principal e depois várias opções internas relacionadas ou seja um departamento com vários subdepartamentos.',
                exampleText:
                  'O cliente escolhe a opção Vendas e dentro dela terá mais duas opções Vendas Matriz e Vendas Filial.',
                exampleImage: flowDepartment,
                imageWidth: 170,
                exampleNode: (
                  <>
                    <div className={classes.exampleFlow}>
                      <Radio disabled className={classes.checkbox} />
                      <strong>1</strong> Vendas
                    </div>
                    <div className={classes.separator} />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px'
                      }}
                    >
                      <div className={classes.boxDepartmentExample}>
                        <CircleSmall />
                        Vendas Matriz
                        <Headset size={18} />
                      </div>
                      <div className={classes.boxDepartmentExample}>
                        <CircleSmall />
                        Vendas Filial
                        <Headset size={18} />
                      </div>
                    </div>
                  </>
                )
              })}
            </Grid>
          </Grid>
        )

      case 1:
        return (
          <Grid container className={classes.container}>
            {!values.menuOption && (
              <>
                <Grid item xs={12} className={classes.contentTitle}>
                  <h2>Configure o Menu Principal e seus Subdepartamentos</h2>
                  <span>
                    O menu principal é o departamento pai. Dentro dele. adicione
                    os subdepartamentos que o cliente poderá escolher.
                  </span>
                </Grid>

                <Grid item xs={12} className={classes.boxMenuDepartment}>
                  <div className={classes.contentMenuDepartment}>
                    <Workflow />
                    <h3>Menu Principal</h3>
                  </div>
                  <InputField
                    label="Nome do Menu Principal"
                    name="parentName"
                    value={values.parentName || ''}
                    onChange={e => setFieldValue('parentName', e.target.value)}
                    error={touched.parentName && Boolean(errors.parentName)}
                    helperText={touched.parentName && errors.parentName}
                  />
                </Grid>
              </>
            )}

            <FieldArray name="subDepartments">
              {({ push, remove, replace }) => (
                <>
                  {/* Formulário */}
                  <Grid item xs={12} className={classes.boxForm}>
                    {values.menuDepartment && (
                      <div className={classes.contentMenuDepartment}>
                        <Minus />
                        <h3>
                          {isEditingSubIndex !== null
                            ? `Editar Subdepartamento #${isEditingSubIndex + 1}`
                            : `Novo Subdepartamento${values.parentName
                              ? ` de ${values.parentName}`
                              : ''
                            }`}
                        </h3>
                      </div>
                    )}

                    <Grid
                      container
                      spacing={2}
                      style={{ display: 'flex', alignItems: 'flex-end' }}
                    >
                      <Grid item xs={5}>
                        <InputField
                          label={
                            values.menuDepartment
                              ? 'Nome do Subdepartamento'
                              : 'Nome do Fluxo Simples'
                          }
                          value={tempSub.name}
                          spellCheck={true}
                          onChange={e =>
                            setTempSub(prev => ({
                              ...prev,
                              name: e.target.value
                            }))
                          }
                          placeholder="Ex: Vendas Matriz"
                          fullWidth
                          size="small"
                          className={classes.input}
                          name="tempSubName"
                          id="tempSubName"
                          emoji
                        />
                      </Grid>

                      <Grid item xs={7}>
                        <UsersFilter
                          key={usersSelectKey}
                          label="Usuários do Departamento de Destino"
                          initialUsers={tempSub.users || []}
                          onFiltered={selectedUsers => {
                            setTempSub(prev => ({
                              ...prev,
                              users: selectedUsers
                            }))
                            if (isEditingSubIndex !== null) {
                              setFieldValue(
                                `subDepartments.${isEditingSubIndex}.users`,
                                selectedUsers
                              )
                            }
                          }}
                        />
                      </Grid>

                      {/* <Grid item xs={3}>
                        <InputSwitch
                          label="Aguardar Atendente"
                          checked={tempSub.exitChatbot}
                          disabled={
                            values.forwardQueueId && !values.exitChatbot
                          }
                          onChange={e =>
                            setTempSub(prev => ({
                              ...prev,
                              exitChatbot: e.target.checked
                            }))
                          }
                          name="exitChatbot"
                          size="small"
                        />
                      </Grid> */}
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Grid item xs={5}>
                        <InputMessage
                          value={tempSub.greetingMessage}
                          onChange={e =>
                            setTempSub(prev => ({
                              ...prev,
                              greetingMessage: e.target.value
                            }))
                          }
                          placeholder="Olá! Seja bem-vindo(a)..."
                          label="Mensagem de Saudação"
                          fullWidth
                          name="TempSubGreetingMessage"
                          id="TempSubGreetingMessage"
                          emoji
                        />
                        {/* <InputField
                          // multiline
                          value={tempSub.greetingMessage}
                          spellCheck={true}
                          size="small"
                          // className={classes.input}
                          onChange={e =>
                            setTempSub(prev => ({
                              ...prev,
                              greetingMessage: e.target.value
                            }))
                          }
                          placeholder="Olá! Seja bem-vindo(a)..."
                          label="Mensagem de Saudação"
                          fullWidth
                          name="TempSubGreetingMessage"
                          id="TempSubGreetingMessage"
                          emoji
                        /> */}
                      </Grid>

                      <Grid
                        item
                        xs={7}
                        className={classes.attachmentContainer}
                        style={{ display: 'flex', alignItems: 'flex-start' }}
                      >
                        <AttachmentInput
                          type="image"
                          mediaPath={tempSub.mediaPath}
                          mediaName={tempSub.mediaName}
                          displayName={tempSub.name || 'subdepartamento'}
                          classes={classes}
                          onPreview={path => {
                            setPreviewUrl(path)
                            setImagePreviewOpen(true)
                          }}
                          onFileSelect={(file, previewUrl) => {
                            setTempSub(prev => ({
                              ...prev,
                              attachmentFile: file,
                              mediaPath: previewUrl,
                              mediaName: file.name
                            }))
                          }}
                          onFileRemove={() => {
                            setTempSub(prev => ({
                              ...prev,
                              attachmentFile: null,
                              mediaPath: null,
                              mediaName: null
                            }))
                            if (optionAttachmentFile.current) {
                              optionAttachmentFile.current.value = null
                            }
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <InputSwitch
                        label="Aguardar Atendente"
                        checked={tempSub.exitChatbot}
                        disabled={values.forwardQueueId && !values.exitChatbot}
                        onChange={e =>
                          setTempSub(prev => ({
                            ...prev,
                            exitChatbot: e.target.checked
                          }))
                        }
                        name="exitChatbot"
                        size="small"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      className={classes.boxContainerAttachmentAndActions}
                    >
                      {values.menuDepartment && (
                        <Grid
                          item
                          xs={12}
                          className={classes.actionButtonsForm}
                        >
                          {isEditingSubIndex !== null && (
                            <ButtonSecondary
                              label="Cancelar"
                              onClick={() => {
                                setTempSub(createEmptySubDepartment())
                                setIsEditingSubIndex(null)
                                setUsersSelectKey(prev => prev + 1)
                              }}
                            />
                          )}
                          {!!(
                            values.parentName?.trim() && tempSub.name?.trim()
                          ) && (
                              <ButtonPrimary
                                label={
                                  isEditingSubIndex !== null
                                    ? 'Atualizar'
                                    : 'Adicionar'
                                }
                                onClick={() => {
                                  const subData = { ...tempSub }
                                  if (isEditingSubIndex !== null) {
                                    replace(isEditingSubIndex, subData)
                                  } else {
                                    push(subData)
                                  }
                                  setTempSub(createEmptySubDepartment())
                                  setIsEditingSubIndex(null)
                                  setUsersSelectKey(prev => prev + 1)
                                }}
                              />
                            )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  {values.menuDepartment &&
                    values.subDepartments?.length > 0 && (
                      <>
                        <div className={classes.contentMenuDepartment}>
                          <h3>
                            Subdepartamentos de "{values.parentName}" (
                            {values.subDepartments?.length || 0})
                          </h3>
                        </div>
                        <Box className={classes.boxList}>
                          {values.subDepartments.map((sub, index) => (
                            <Box key={index} className={classes.list}>
                              <Box
                                display="flex"
                                alignItems="center"
                                gap="12px"
                              >
                                <span className={classes.circle} />
                                <Box>
                                  <Typography
                                    variant="body1"
                                    className={classes.textList}
                                  >
                                    {index + 1}. {sub.name}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    className={classes.textAttendants}
                                  >
                                    {sub.users?.length || 0} atendentes
                                  </Typography>
                                </Box>
                              </Box>

                              <Box className={classes.contentActionsButtons}>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    const subToEdit = { ...sub }
                                    setTempSub(subToEdit)
                                    setIsEditingSubIndex(index)
                                    setUsersSelectKey(prev => prev + 1)
                                  }}
                                  className={classes.iconButtonEdit}
                                >
                                  <Edit2 size={18} />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  className={classes.iconButtonDelete}
                                  onClick={() => remove(index)}
                                >
                                  <Trash2 size={18} />
                                </IconButton>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </>
                    )}
                </>
              )}
            </FieldArray>
          </Grid>
        )

      case 2:
        const SubDepartmentsSummaryList = () => (
          <>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: '12px' }}
            >
              Subdepartamentos ({values.subDepartments?.length || 0})
            </Typography>
            <Grid container className={classes.boxSummarySubdepartments}>
              {values.subDepartments?.map((sub, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  className={classes.boxSubdepartments}
                >
                  <Box className={classes.boxSubdepartmentsTitle}>
                    <span className={classes.circle} />
                    <Typography variant="body2" className={classes.textList}>
                      {index + 1}. {sub.name || 'Sem nome'}
                    </Typography>
                  </Box>
                  <Typography variant="caption" color="textSecondary">
                    {sub.users?.length || 0} atendentes
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </>
        )

        return (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={classes.contentTitle}>
                <h2>Revise seu fluxo</h2>
                <span>Confirme as configurações antes de criar</span>
              </div>

              <Box className={classes.boxSummary}>
                <Typography variant="caption" color="textSecondary">
                  Tipo de Fluxo
                </Typography>
                <Typography variant="h6" className={classes.summaryTitle}>
                  {values.menuDepartment
                    ? 'Fluxo com menu e subdepartamentos'
                    : 'Fluxo Simples por Departamento'}
                </Typography>

                {values.menuDepartment && (
                  <Box className={classes.boxSummaryContent}>
                    <div className={classes.roundedName}>
                      {values.parentName
                        ? values.parentName.charAt(0).toUpperCase()
                        : 'M'}
                    </div>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        className={classes.menuName}
                      >
                        {values.parentName || 'Não preenchido'}
                      </Typography>
                      <Typography
                        variant="caption"
                        className={classes.menuDescription}
                      >
                        Menu Principal (Departamento Pai)
                      </Typography>
                    </Box>
                  </Box>
                )}

                <SubDepartmentsSummaryList />
              </Box>
            </Grid>
          </Grid>
        )
      default:
        return 'Passo desconhecido'
    }
  }

  return (
    <>
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        onClose={onClose}
        scroll="paper"
        className={classes.dialogContent}
      >
        <DialogTitle>
          <Grid container spacing={2} className={classes.boxTitle}>
            <Grid item xs={6} className={classes.boxTitleText}>
              Criar Fluxo de Atendimento
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.boxStepper}>
                <Box className={classes.boxStepperContent}>
                  <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    style={{ padding: 0, backgroundColor: 'transparent' }}
                    connector={<StepConnector />}
                    onClick={() => isEditing && null}
                  >
                    {steps.map((label, index) => {
                      if (isEditing && index === 0) return null
                      return (
                        <Step
                          key={label}
                          style={{
                            paddingLeft: index === 0 ? 0 : '15px',
                            paddingRight: '15px'
                          }}
                        >
                          <StepLabel
                            StepIconComponent={props => {
                              const { active, completed } = props
                              return (
                                <div
                                  className={classes.stepLabel}
                                  style={{
                                    backgroundColor: active
                                      ? theme.palette.blue_300.main
                                      : completed
                                        ? theme.palette.green_200.main
                                        : theme.palette.gray_100.main,
                                    color: active
                                      ? '#fff'
                                      : completed
                                        ? '#fff'
                                        : theme.palette.gray_400.main
                                  }}
                                >
                                  {active
                                    ? activeStep + 1
                                    : completed
                                      ? '✓'
                                      : props.icon}
                                </div>
                              )
                            }}
                          ></StepLabel>
                        </Step>
                      )
                    })}
                  </Stepper>

                  <Typography
                    variant="body2"
                    className={classes.stepFromToStep}
                  >
                    Passo {activeStep + 1} de {steps.length}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogTitle>
        {initialData && (
          <Formik
            initialValues={initialData}
            enableReinitialize
            validationSchema={getValidationSchema(activeStep)}
            onSubmit={async (values, actions) => {
              const finalValues = { ...values }

              if (isEditingSubIndex !== null) {
                const updatedSubs = [...values.subDepartments]
                updatedSubs[isEditingSubIndex] = { ...tempSub }
                finalValues.subDepartments = updatedSubs
              }

              if (activeStep === 1 && values.menuOption) {
                finalValues.subDepartments = [tempSub]
                actions.setFieldValue('subDepartments', [tempSub])
                Object.assign(finalValues, {
                  name: tempSub.name,
                  greetingMessage: tempSub.greetingMessage,
                  exitChatbot: tempSub.exitChatbot,
                  attachmentFile: tempSub.attachmentFile,
                  mediaPath: tempSub.mediaPath,
                  mediaName: tempSub.mediaName
                })
              }

              if (activeStep < steps.length - 1) {
                handleNext()
                actions.setSubmitting(false)
              } else {
                const saved = await handleSave(finalValues)
                if (saved) onClose()
                actions.setSubmitting(false)
              }
            }}
          >
            {formikProps => (
              <Form>
                <DialogContent dividers style={{ minHeight: '430px' }}>
                  {renderStepContent(activeStep, formikProps)}
                </DialogContent>

                <DialogActions className={classes.dialogActions}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{ gap: '8px' }}
                    >
                      <ButtonSecondary onClick={onClose} label="Cancelar" />
                      {isEditing && (
                        <IconButton
                          type="button"
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            handleDeleteOptions()
                          }}
                          className={classes.deleteButton}
                        >
                          <Trash2 />
                        </IconButton>
                      )}
                    </Box>

                    <Box
                      className={classes.boxActionsButtons}
                      display="flex"
                      alignItems="center"
                      style={{ gap: '8px' }}
                    >
                      {(!isEditing || activeStep > 1) && activeStep > 0 && (
                        <ButtonSecondary
                          disabled={isEditing && activeStep === 1}
                          onClick={activeStep === 0 ? onClose : handleBack}
                          label={activeStep === 0 ? 'Cancelar' : 'Voltar'}
                        />
                      )}
                      <ButtonPrimary
                        type="submit"
                        disabled={
                          formikProps.isSubmitting ||
                          (activeStep === 0 &&
                            !formikProps.values.menuOption &&
                            !formikProps.values.menuDepartment) ||
                          (activeStep === 1 &&
                            formikProps.values.menuDepartment &&
                            (!formikProps.values.parentName?.trim() ||
                              !(
                                formikProps.values.subDepartments?.length > 0
                              ))) ||
                          (activeStep === 1 &&
                            !formikProps.values.menuDepartment &&
                            !tempSub.name?.trim())
                        }
                        label={
                          activeStep === steps.length - 1
                            ? isEditing
                              ? 'Salvar'
                              : 'Criar'
                            : 'Próximo'
                        }
                      />
                    </Box>
                  </Box>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
      </Dialog>

      <Dialog
        maxWidth="xs"
        fullWidth
        open={imagePreviewOpen}
        onClose={() => setImagePreviewOpen(false)}
      >
        <DialogContent className={classes.dialogContentPreview}>
          <img
            src={getMediaUrl(previewUrl)}
            alt="Preview em Tela Cheia"
            className={classes.imagePreview}
            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
          />
        </DialogContent>
        <DialogActions>
          <ButtonSecondary
            onClick={() => setImagePreviewOpen(false)}
            label="Fechar"
          />
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        title="Deletar Anexo do Setor ou Subsetor"
        open={confirmationOpenOption}
        onClose={() => setConfirmationOpenOption(false)}
        onConfirm={deleteOptionMedia}
      >
        Tem certeza de que deseja excluir o anexo? Esta ação não pode ser
        desfeita.
      </ConfirmationModal>

      <ConfirmationModal
        title="Excluir Departamento"
        open={confirmationOpenDepartment}
        onClose={() => {
          setConfirmationOpenDepartment(false)
          setDeleteConfirmationText('')
        }}
        onConfirm={handleConfirmDeleteDepartment}
      >
        <div>
          <Typography variant="body1">
            Para confirmar a exclusão do departamento, digite "EXCLUIR" no campo
            abaixo:
          </Typography>
          <InputField
            value={deleteConfirmationText}
            onChange={e =>
              setDeleteConfirmationText(e.target.value.toUpperCase())
            }
            label="Confirme a exclusão"
            fullWidth
            autoFocus
          />
        </div>
      </ConfirmationModal>
    </>
  )
}

export default DepartmentModal
